import { useEffect } from "react";
import { useRouter } from "next/router";
import { apolloClient } from '@lib/apollo';
import urlJoin from "url-join";
import { GetStaticPaths, GetStaticProps, InferGetStaticPropsType, NextPage } from 'next';
import { PropertyDetailsLanding } from '@features/property-details/containers/PropertyDetailsLanding';
import AppLayout from '@layouts/AppLayout';
import AppHead from '@core/components/common/AppHead';
import GET_PROPERTY_SETTINGS from '@graphql/get-property-settings';
import GET_PROPERTIES_DETAILS_BY_SLUG from '@graphql/get-property-details-by-slug';
import { AppMetaData } from "@core/constants/app-meta-data";
import { usePropertyState } from "@core/providers/PropertyStateProvider";
import { getPropertyDetailsSeoData } from "@core/seo/PropertyDetailsSeoUtil";


const PropertyDetailsPage: NextPage = ({
                                           time,
                                           propertyDetailsData
                                       }: InferGetStaticPropsType<typeof getStaticProps>) => {

    const { setPropertyDetailsData } = usePropertyState();

    const { asPath } = useRouter();
    const seoUrl = urlJoin(AppMetaData.WEB_URL || "", asPath);

    useEffect(() => {

        setPropertyDetailsData(JSON.stringify(propertyDetailsData));

    }, [propertyDetailsData])

    return (
        <>
            {/*{time}*/}

            <AppHead title={getPropertyDetailsSeoData(propertyDetailsData).title}
                     description={`${getPropertyDetailsSeoData(propertyDetailsData).description.replace(/(<([^>]+)>)/ig, '')}`}
                     openGraph={{
                         url: seoUrl,
                         title: getPropertyDetailsSeoData(propertyDetailsData).title,
                         description: getPropertyDetailsSeoData(propertyDetailsData).description.replace(/(<([^>]+)>)/ig, ''),
                         locale: getPropertyDetailsSeoData(propertyDetailsData).locale,
                         siteName: getPropertyDetailsSeoData(propertyDetailsData).siteName,
                         images: getPropertyDetailsSeoData(propertyDetailsData).images
                     }}
            />

            <PropertyDetailsLanding />
        </>
    );
};

// @ts-expect-error
PropertyDetailsPage.getLayout = function getLayout(page: typeof PropertyDetailsPage) {
    return (
        <AppLayout requireAuth={false}>
            {/*// @ts-expect-error*/}
            {page}
        </AppLayout>
    );
};

export const getStaticPaths: GetStaticPaths = async () => {

    const client = apolloClient(false);
    await client.resetStore();

    const { data: propertySlugs, errors: propertySlugsQueryError } = await client.query({
        query: GET_PROPERTY_SETTINGS,
        fetchPolicy: 'network-only'
    });

    // console.log(propertySlugs, 'propertiesData');
    // console.log(propertySlugsQueryError, 'propertySlugsQueryError');

    // PATHS WE KNOW UP FRONT
    const propertyPaths = propertySlugs.getAllSettings.map((settings) => {
        return {
            params: { slug: settings.slug },
        };
    });

    // console.log(propertyPaths, 'propertyPaths');

    return {
        paths: propertyPaths,

        // Enable statically generating additional pages
        fallback: true,
    };
};

export const getStaticProps: GetStaticProps = async ({ params }) => {

    let _propertyData = null;

    // if (isProd) {
    const client = apolloClient(false);
    await client.resetStore();

    const { data: propertyData, errors: propertiesQueryError } = await client.query({
        query: GET_PROPERTIES_DETAILS_BY_SLUG,
        fetchPolicy: 'network-only',
        variables: {
            slug: params.slug
        }
    });

    _propertyData = propertyData.getPropertyBySlug;

    // console.log(propertyData.getPropertyById, 'IN PROPERTIES SLUG PAGE::carousalData');
    // console.log(propertiesQueryError, 'IN PROPERTIES SLUG PAGE::propertiesQueryError');
    // }

    /*if (isDev) {
        // eslint-disable-next-line prefer-destructuring
        _propertyData = getPropertyBySlug(params.slug.toString())[0]
    }*/

    return {
        props: {
            propertyDetailsData: _propertyData, //propertyData.getPropertyBySlug,
            time: new Date().toISOString()
        },
        revalidate: 1,
    };
};

export default PropertyDetailsPage;
